



































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class SkalaNyeri extends Vue {
  @Prop() setSkalaNyeri!: number;
  @Prop() radioNyeri!: boolean;
  @Prop() infoNyeri!: boolean;
  colSkala = "";
  // radioNyeri = true;
  // skalaNyeri = 0;
  // radioSkala = null;
  warna = "green";
  skala = "Tidak Nyeri";
  rangeSkala = ["0", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  @Watch("setSkalaNyeri")
  changeNyeri(val) {
    if (this.infoNyeri == true) {
      this.colSkala == "9";
    } else {
      this.colSkala = "12";
    }
    if (this.setSkalaNyeri == 0) {
      // this.radioSkala = 1;
      this.warna = "green";
      this.skala = "Tidak Nyeri";
    } else if (this.setSkalaNyeri < 4) {
      // this.radioSkala = 2;
      this.warna = "#FBC02D";
      this.skala = "Nyeri Ringan";
    } else if (this.setSkalaNyeri < 7) {
      // this.radioSkala = 3;
      this.warna = "#F57C00";
      this.skala = "Nyeri Sedang";
    } else {
      // this.radioSkala = 4;
      this.warna = "#DD2C00";
      this.skala = "Nyeri Berat";
    }
    this.$emit("skalaNyeri", val);
  }

  get radioSkala() {
    if (this.setSkalaNyeri == 0) {
      return 1;
    } else if (this.setSkalaNyeri < 4) {
      return 2;
    } else if (this.setSkalaNyeri < 7) {
      return 3;
    } else {
      return 4;
    }
  }

  set radioSkala(val) {
    if (val == 1) {
      this.setSkalaNyeri = 0;
    } else if (val == 2) {
      this.setSkalaNyeri = 1;
    } else if (val == 3) {
      this.setSkalaNyeri = 4;
    } else {
      this.setSkalaNyeri = 7;
    }
  }
  // @Watch("radioSkala")
  // changeRadioSkala() {
  //   if (this.radioSkala == 1) {
  //     // console.log("1");
  //     this.skalaNyeri = 0;
  //   } else if (this.radioSkala == 2) {
  //     // console.log("2");
  //     // this.skalaNyeri = 1;
  //     let skala = null;
  //     if (this.skalaNyeri > 2) skala = this.skalaNyeri;
  //     else skala = 2;
  //     this.skalaNyeri = skala;
  //   } else if (this.radioSkala == 3) {
  //     // console.log("3");
  //     let skala = null;
  //     if (this.skalaNyeri > 3) skala = this.skalaNyeri;
  //     else skala = 3;
  //     this.skalaNyeri = skala;
  //     // this.skalaNyeri = 4;
  //   } else {
  //     // console.log("4");
  //     let skala = null;
  //     if (this.skalaNyeri > 7) skala = this.skalaNyeri;
  //     else skala = 7;
  //     this.skalaNyeri = skala;
  //     // this.skalaNyeri = 7;
  //   }
  // }

  // get skalaNyeri() {
  //   return this.setSkalaNyeri;
  // }
  // set skalaNyeri(v) {
  //   console.log("setSkalaNyeri", v);
  //   if (v == 0) {
  //     this.radioSkala = 1;
  //     this.warna = "green";
  //     this.skala = "Tidak Nyeri";
  //   } else if (v < 4) {
  //     this.radioSkala = 2;
  //     this.warna = "#FBC02D";
  //     this.skala = "Nyeri Ringan";
  //   } else if (v < 7) {
  //     this.radioSkala = 3;
  //     this.warna = "#F57C00";
  //     this.skala = "Nyeri Sedang";
  //   } else {
  //     this.radioSkala = 4;
  //     this.warna = "#DD2C00";
  //     this.skala = "Nyeri Berat";
  //   }
  //   this.$emit("skalaNyeri", v);
  // }

  // get radioSkala() {
  //   return this.radioSkala;
  // }
  // set radioSkala(v) {
  //   if (this.radioSkala == 1) {
  //     // console.log("1");
  //     this.skalaNyeri = 0;
  //   } else if (this.radioSkala == 2) {
  //     // console.log("2");
  //     this.skalaNyeri = 1;
  //   } else if (this.radioSkala == 3) {
  //     // console.log("3");
  //     this.skalaNyeri = 4;
  //   } else {
  //     // console.log("4");
  //     this.skalaNyeri = 7;
  //   }
  // }
  // @Watch("setSkalaNyeri")
  // valSkalaNyeri(val) {
  //   console.log("setSkalaNyeri", val);
  //   this.skalaNyeri = val;
  // }
}
